<template>
  <div class="group-ranking">
    <div v-show="joinedGroup" class="list">
      <ranking-list :items="leaderboards" />
      <transition name="fade-in-up" appear>
        <div class="current-ranking">
          <div class="image">
            <webp-image :src="myGroup.icon" alt="logo" width="100%" height="100%" />
          </div>
          <div class="name">{{ myGroup.name }}<br/><small>第 {{myGroup.ranking}} 名</small></div>
          <div class="course">{{ duration2course(myGroup.duration) }}</div>节
        </div>
      </transition>
    </div>
    <div v-show="!joinedGroup" class="joinin">
      <webp-image class="image" src="https://cdn.llscdn.com/fe-static/lls-with-tfchina/school-VO6WsvMr.png" />
      <h2>加入高校战队</h2>
      <p>除了自己捐课，你还可以加入自己喜欢的高校战队，为它助力。</p>
      <touch tag="button" class="open-groups" type="button" @tap="gotoGroups">加入高校战队</touch>
      <p class="tip">*加入高校战队不影响个人捐赠记录和排名哦~</p>
    </div>
  </div>
</template>

<script>
  import actions from '@/store/action-types'

  import WebpImage from '@/components/common/WebpImage'
  import RankingList from '@/components/RankingList'

  export default {
    name: 'group-ranking',
    computed: {
      basicDonateDuration () {
        return this.$store.state.BASIC_DONATE_DURATION
      },
      joinedGroup () {
        return this.$store.state.leaderboard.joinedGroup
      },
      myGroup () {
        return this.$store.state.leaderboard.group.mine
      },
      leaderboards () {
        return this.$store.state.leaderboard.group.leaderboards
      }
    },
    activated () {
      this.getGroupLeaderboard()
    },
    methods: {
      duration2course (duration) {
        return Math.floor(duration / this.basicDonateDuration)
      },
      getGroupLeaderboard () {
        this.$store.dispatch(actions.fetch.GROUP_LEADERBOARD)
      },
      gotoGroups () {
        // this.$track.sendActionTrack('csr_rank', 'click_join')
        // this.$router.replace('groups')
        alert('活动已结束')
      }
    },
    components: {
      WebpImage,
      RankingList
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/scss/vars";

  .group-ranking {
    background-color: $white;
    .current-ranking {
      position: fixed;
      left: 0;
      bottom: 0;
      z-index: 12;
      display: flex;
      width: 100%;
      height: 130px;
      padding: 25px 40px;
      font-size: 28px;
      color: $white;
      line-height: 80px;
      background-color: $red;
      box-sizing: border-box;
      .image {
        width: 80px;
        height: 80px;
        margin-left: 65px;
        margin-right: 30px;
        font-size: 0;
        text-align: center;
        border-radius: 50%;
        overflow: hidden;
      }
      .name {
        @include text-ellipsis;
        flex: 1;
        font-size: 30px;
        line-height: 40px;
        small {
          font-size: 28px;
          color: rgba($white, 0.87);
        }
      }
      .course {
        margin-right: 10px;
        font-size: 48px;
        font-weight: 400;
      }
    }
    .joinin {
      padding-top: 120px;
      padding-left: 40px;
      padding-right: 40px;
      text-align: center;
      box-sizing: border-box;
      .image {
        width: 510px;
        height: 385px;
      }
      h2 {
        margin-top: 100px;
        font-size: 48px;
        color: $black;
        line-height: 60px;
      }
      p {
        width: 530px;
        margin-top: 20px;
        margin-left: auto;
        margin-right: auto;
        font-size: 30px;
        color: rgba($black, 0.54);
        line-height: 45px;
        &.tip {
          width: 100%;
          margin-top: 30px;
          font-size: 24px;
          color: rgba($black, 0.2);
        }
      }
      .open-groups {
        @include reset-button;
        width: 100%;
        height: 88px;
        margin-top: 60px;
        font-size: 28px;
        color: #ccc;
        letter-spacing: 9px;
        line-height: 88px;
        background-color: $darkRed;
        border-radius: 44px;
      }
    }
  }
  .fade-in-up-enter-active {
    transition: all 0.5s 0.5s ease-in;
  }
  .fade-in-up-enter {
    transform: translate3d(0, 100%, 0);
  }
  @media screen and (min-weight: 650) {
    .group-ranking {
      .joinin {
        padding-top: 100px;
        h2 {
          margin-top: 40px;
        }
      }
      .open-groups {
        margin-top: 40px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// GroupRanking.vue?78aa06ec